import { decomposeColor, hslToRgb } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import VoxelInput from '../../../components/voxel/Forms/VoxelInput';

export interface HexColorPickerProps {
  color: string;
  setColor: (color: string) => void;
}

export const HexColorPicker: React.FC<HexColorPickerProps> = ({ color, setColor }) => {
  // Temporary hex color
  const [localColor, setLocalColor] = useState<string>(color);

  // Reset local color if needed
  useEffect(() => {
    if (color !== localColor) setLocalColor(color);
  }, [color]);

  // Update color if valid and new
  useEffect(() => {
    try {
      if (!localColor) return; // Don't update if empty
      if (localColor === color) return; // Don't update if same
      if (localColor.length !== 7) return;
      const decomposedColor = decomposeColor(localColor);

      // If decomposing color worked that means we can update the color
      setColor(localColor);
    } catch {
      console.log('crash');
    }
  }, [localColor]);

  return (
    <VoxelInput
      labelPosition="top"
      id={''}
      label="Hex"
      deleteValue={() => setLocalColor('#')}
      value={localColor}
      onChange={(event) =>
        setLocalColor('#' + event.target.value?.replaceAll(/[^A-Fa-f0-9]+/gm, '')?.slice(0, 6))
      }
    />
  );
};

export default HexColorPicker;
